import React, {type FC} from 'react'
import {Button, Text, useGetAdaptiveStyle} from 'uikit'
import {useAppSelector, useAppDispatch} from 'store'
import {getTranslates} from 'store/translates/selectors'
import {getStatusModal} from 'store/modal/selectors'
import {addRewardedTries} from 'store/secretword/slice'
import {hideModalThunk} from 'store/modal/thunk'
import {YandexService} from 'services/yandexSDK'
import {StartGameMobileButton} from 'src/common/components/StartGameMobileButton'
import {adaptiveConfigImgWidth, adaptiveConfigModal} from 'src/common/components/GamePage/consts'
import type {CallbackType} from 'store/modal/entities'
import {GameOverImg} from 'src/common/components/GameOverImg'
import {ModalWrap} from '../ModalWrap'
import styles from './LoseModal.scss'

export const LoseModal: FC<{}> = () => {
  const {style: styleWrapperImg} = useGetAdaptiveStyle([adaptiveConfigImgWidth])
  const {style} = useGetAdaptiveStyle(adaptiveConfigModal)

  const dispatch = useAppDispatch()
  const translates = useAppSelector(getTranslates)
  const status = useAppSelector(getStatusModal)

  const handleAddTries = () => {
    YandexService.rewardedVideo(() => {
      dispatch(addRewardedTries())
      dispatch(hideModalThunk(null))
    })
  }

  const handleClose = (callback: CallbackType) => dispatch(hideModalThunk(callback))
  const isRewarded = YandexService.isSDK()

  return ( 
    <ModalWrap classes={{modal: styles.wrapper, cross: styles.cross}} style={style}>
      <Text type="title" color="secondary">{translates.YOU_LOSE}</Text>
      <div className={styles.imgStyle} style={styleWrapperImg}><GameOverImg /></div>
      {isRewarded &&
        <Button onClick={handleAddTries} color="rewarded" size="big">
          {translates.CONTINUE_WITH_AD}
        </Button>
      }
      <StartGameMobileButton
        onClick={handleClose}
        disabled={status === 'close'}
        size={isRewarded ? 'middle' : 'big'}
      />
    </ModalWrap>
  )
}
